import { isValidGeoCoord, lookupPincodeCoordinates, parseCoord } from "./geo";

function pickDefaultAddress(user) {
  const addresses = user?.customerDetails?.addresses;
  if (!Array.isArray(addresses) || addresses.length === 0) return null;
  return addresses.find((item) => item?.isDefault) || addresses[0];
}

function buildLabel(parts) {
  return parts.filter(Boolean).join(", ") || "Registered location";
}

export async function resolveRegisteredLocation(user) {
  if (!user) return null;

  const addr = pickDefaultAddress(user);
  const structured = user?.address || {};

  const city = addr?.city || structured.city || "";
  const state = addr?.state || structured.state || "";
  const area = addr?.area || structured.area || "";
  const pincode =
    addr?.pincode ||
    structured.postalCode ||
    user?.customerDetails?.pincode ||
    "";

  const directLat = parseCoord(addr?.lat ?? addr?.latitude ?? structured.latitude);
  const directLng = parseCoord(addr?.lng ?? addr?.longitude ?? structured.longitude);

  const label = buildLabel([area, city, state].filter(Boolean));

  if (isValidGeoCoord(directLat, directLng)) {
    return { lat: directLat, lng: directLng, label, source: "registered", pincode };
  }

  if (pincode) {
    const coords = await lookupPincodeCoordinates(pincode);
    if (isValidGeoCoord(coords?.lat, coords?.lng)) {
      return {
        lat: coords.lat,
        lng: coords.lng,
        label: label || `Pincode ${pincode}`,
        source: "registered",
        pincode,
      };
    }
  }

  if (!city && !pincode) return null;

  return {
    lat: null,
    lng: null,
    label: label || "Registered location",
    pincode,
    source: "registered",
  };
}

export async function resolveRegisteredLocationCoords(registered) {
  if (!registered) return null;
  if (isValidGeoCoord(registered.lat, registered.lng)) {
    return registered;
  }
  if (registered.pincode) {
    const coords = await lookupPincodeCoordinates(registered.pincode);
    if (isValidGeoCoord(coords?.lat, coords?.lng)) {
      return { ...registered, lat: coords.lat, lng: coords.lng };
    }
  }
  return null;
}

export function requestCurrentPosition() {
  return new Promise((resolve) => {
    if (typeof window === "undefined" || !navigator.geolocation) {
      resolve({ coords: null, error: "Location is not supported in this browser." });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          coords: {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            label: "Current location",
            source: "current",
          },
          error: "",
        });
      },
      (geoError) => {
        const error =
          geoError?.code === 1
            ? "Enable location access to see nearby shops within 100 km."
            : "Could not detect your current location.";
        resolve({ coords: null, error });
      },
      { enableHighAccuracy: false, timeout: 12000, maximumAge: 0 }
    );
  });
}
